import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=70a8ee3e"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=70a8ee3e&prod&lang=sass"
import style1 from "./PaymentMethods.vue?vue&type=style&index=1&id=70a8ee3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports